import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { type ScrollbarProps, Scrollbars } from 'react-custom-scrollbars';
import styled from 'styled-components';

const ThumbHorizontal = styled.div`
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
`;

const TrackHorizontal = styled.div`
  min-width: 100%;
  z-index: 150;
  bottom: -2px;
`;

export interface HScrollbarHanlders {
  scrollLeft: () => void;
  scrollRight: () => void;
}

const ScrollbarsHorizontal = forwardRef<HScrollbarHanlders, ScrollbarProps>(
  (props: ScrollbarProps, ref) => {
    const scrollBarRef = useRef<Scrollbars>(null);

    useImperativeHandle(ref, () => ({
      scrollLeft: () => {
        const step = scrollBarRef.current?.getClientWidth() ?? 0;
        const left = scrollBarRef.current?.getScrollLeft() ?? 0;
        scrollBarRef.current?.scrollLeft(left - step);
      },
      scrollRight: () => {
        const step = scrollBarRef.current?.getClientWidth() ?? 0;
        const left = scrollBarRef.current?.getScrollLeft() ?? 0;
        scrollBarRef.current?.scrollLeft(left + step);
      },
    }));

    return (
      <Scrollbars
        renderTrackHorizontal={(tProps: any) => <TrackHorizontal {...tProps} />}
        renderThumbHorizontal={(tProps: any) => <ThumbHorizontal {...tProps} />}
        ref={scrollBarRef}
        onWheel={(e) => {
          if (scrollBarRef.current) {
            const y = scrollBarRef.current.getScrollLeft();
            scrollBarRef.current.scrollLeft(y + e.deltaY);
          }
        }}
        {...props}
      />
    );
  }
);

export default ScrollbarsHorizontal;
